import { parsedContent } from '@/lib/utils'

import Configs from '@/configs'

import luggageConvenience from '~/public/images/luggage-storage/convenience.png'
import luggageSecureStorage from '~/public/images/luggage-storage/secure.png'
import luggageCostEffective from '~/public/images/luggage-storage/cost.png'
import luggageNoRestrictions from '~/public/images/luggage-storage/restrictions.png'
import luggageFlexible from '~/public/images/luggage-storage/flexible.png'
import luggageLocalInsights from '~/public/images/luggage-storage/local.png'

import boxConvenience from '~/public/images/box-storage/convenience.png'
import boxSecureStorage from '~/public/images/box-storage/secure-storage.png'
import boxCostEffective from '~/public/images/box-storage/cost-effective.png'
import boxNoRestrictions from '~/public/images/box-storage/no-restrictions.png'
import boxFlexible from '~/public/images/box-storage/flexible.png'
import boxLocalInsights from '~/public/images/box-storage/local-insights.png'

import golfConvenience from '~/public/images/golf-club-storage/convenience.png'
import golfSecureStorage from '~/public/images/golf-club-storage/secure.png'
import golfCostEffective from '~/public/images/golf-club-storage/cost.png'
import golfNoRestrictions from '~/public/images/golf-club-storage/size.png'
import golfFlexible from '~/public/images/golf-club-storage/flexible.png'
import golfLocalInsights from '~/public/images/golf-club-storage/local.png'

import skiConvenience from '~/public/images/ski-storage/convenience.png'
import skiSecureStorage from '~/public/images/ski-storage/secure.png'
import skiCostEffective from '~/public/images/ski-storage/cost.png'
import skiNoRestrictions from '~/public/images/ski-storage/size.png'
import skiFlexible from '~/public/images/ski-storage/flexible.png'
import skiAdditional from '~/public/images/ski-storage/additional.png'

import snowConvenience from '~/public/images/snowboard-storage/convenience.png'
import snowSecureStorage from '~/public/images/snowboard-storage/secure.png'
import snowCostEffective from '~/public/images/snowboard-storage/cost.png'
import snowNoRestrictions from '~/public/images/snowboard-storage/size.png'
import snowFlexible from '~/public/images/snowboard-storage/flexible.png'
import snowLocal from '~/public/images/snowboard-storage/local.png'

const imageClass = { wrClassName: 'w-[190px] h-[160px] mt-4' }

const appName = Configs.APP_NAME

export const STORAGE_IN_CITY = Object.freeze({
  luggageStorage: {
    // sectionClassName: 'skip-bottom--spacing',
    header: {
      title: parsedContent(`Luggage Storage in New York with <strong>${appName}</strong>`),
      subtitle: parsedContent(
        `
          <p>One thing that can put a damper on your travel experience is lugging around heavy suitcases. Thankfully, <strong>${appName}</strong> is here to save the day with unparalleled <strong>luggage storage options in NYC</strong>.</p>
          <p class="text-secondary font-semibold pt-3 md-mn:text-2xl capitalize">Seamless and affordable luggage storage in New York</p>
        `,
        'max-w-[1050px]'
      )
    },
    content: {
      descriptionWrClass: 'md-mn:grid-cols-2 lg-mn:grid-cols-3 gap-7',
      data: [
        {
          image: {
            src: luggageConvenience,
            alt: 'convenience',
            ...imageClass
          },
          heading: parsedContent('Convenience at Your Fingertips', 'text-blue-river'),
          subheading: parsedContent(
            `<strong>${appName}</strong> offers a user-friendly app and website, allowing travelers to easily locate and reserve secure storage facilities worldwide. Whether you're in New York City or exploring another destination, our platform ensures hassle-free luggage storage arrangements.`
          )
        },
        {
          image: {
            src: luggageSecureStorage,
            alt: 'Secure Storage Solutions',
            ...imageClass
          },
          heading: parsedContent('Secure Storage Solutions', 'text-blue-river max-w-[150px]'),
          subheading: parsedContent(
            `Our partners guarantee the safety of your belongings while you explore worry-free. With <strong>${appName}</strong>, you can trust that your possessions are in trusted hands, giving you peace of mind throughout your travels.`
          )
        },
        {
          image: {
            src: luggageCostEffective,
            alt: 'costEffective',
            ...imageClass
          },
          heading: parsedContent('Cost-Effective Daily Rates', 'text-blue-river max-w-[150px]'),
          subheading: parsedContent(
            `Benefit from budget-friendly daily rates starting at just $10 per day/item. Our clear pricing makes it affordable to have a great day without spending too much money.`
          )
        },
        {
          image: {
            src: luggageNoRestrictions,
            alt: 'noRestrictions',
            ...imageClass
          },
          heading: parsedContent('No Size or Weight Restrictions', 'text-blue-river max-w-[175px]'),
          subheading: parsedContent(
            `Unlike traditional storage options, <strong>${appName}</strong> imposes no size or weight restrictions, providing travelers with unparalleled flexibility. Whether you have a small backpack or a big luggage, you can leave what you need and explore the city freely.`
          )
        },
        {
          image: {
            src: luggageFlexible,
            alt: 'Flexible Storage Solutions',
            ...imageClass
          },
          heading: parsedContent('Flexible Storage Solutions', 'text-blue-river max-w-[175px]'),
          subheading: parsedContent(
            `Need storage? <strong>${appName}</strong> has storage options for short or long trips. Our local partners offer storage services for your belongings. You can store your items for as long as you need. This way, you can fully enjoy your time in any destination.`
          )
        },
        {
          image: {
            src: luggageLocalInsights,
            alt: 'localInsights',
            ...imageClass
          },
          heading: parsedContent('Local Insights and Recommendations', 'text-blue-river'),
          subheading: parsedContent(
            `Our local partners can help you find hidden gems, experience authentic dining, and immerse yourself in the local culture. They also offer secure storage options. With <strong>${appName}</strong>, you not only store your luggage but also gain invaluable insights to enhance your travel experience.`
          )
        }
      ]
    }
  },
  boxStorage: {
    // sectionClassName: 'skip-bottom--spacing',
    header: {
      title: parsedContent(`Box Storage in New York with <strong>${appName}</strong>`),
      subtitle: parsedContent(
        `
          <p>Traveling with heavy boxes can make your trip less enjoyable. <strong>${appName}</strong> offers great box storage options in NYC, making it easier for you to travel without the extra weight.</p>
          <p class="text-secondary font-semibold pt-3 md-mn:text-2xl capitalize">Seamless And Affordable Box storage in New York</p>
        `,
        'max-w-[1050px]'
      )
    },
    content: {
      descriptionWrClass: 'md-mn:grid-cols-2 lg-mn:grid-cols-3 gap-7',
      data: [
        {
          image: {
            src: boxConvenience,
            alt: 'convenience',
            wrClassName: 'w-[250px] h-[155px] pt-4'
          },
          heading: parsedContent('Convenience at Your Fingertips', 'text-blue-river'),
          subheading: parsedContent(
            `<strong>${appName}</strong> offers a user-friendly website, allowing travelers to easily locate and reserve secure storage facilities worldwide. Whether you're in New York City or exploring another destination, our platform ensures hassle-free Box storage arrangements.`
          )
        },
        {
          image: {
            src: boxSecureStorage,
            alt: 'Secure Storage Solutions',
            wrClassName: 'w-[140px] h-[155px] pt-4'
            // ...imageClass
          },
          heading: parsedContent('Secure Storage Solutions', 'text-blue-river max-w-[150px]'),
          subheading: parsedContent(
            `Our carefully vetted partners guarantee the safety of your belongings while you explore worry-free. With <strong>${appName}</strong>, you can trust that your possessions are in trusted hands, giving you peace of mind throughout your travels.`
          )
        },
        {
          image: {
            src: boxCostEffective,
            alt: 'costEffective',
            wrClassName: 'w-[208px] h-[155px] pt-4'
            // ...imageClass
          },
          heading: parsedContent('Cost-Effective Daily Rates', 'text-blue-river max-w-[150px]'),
          subheading: parsedContent(
            `Benefit from budget-friendly daily rates starting at just $10 per day/item. Our transparent pricing ensures affordability without compromising on quality, allowing you to enjoy your day to the fullest without breaking the bank.`
          )
        },
        {
          image: {
            src: boxNoRestrictions,
            alt: 'noRestrictions',
            // ...imageClass,
            // className: 'h-[155px]'
            wrClassName: 'w-[190px] h-[155px] pt-4'
          },
          heading: parsedContent('No Size or Weight Restrictions', 'text-blue-river max-w-[175px]'),
          subheading: parsedContent(
            `Unlike traditional storage options, <strong>${appName}</strong> imposes no size or weight restrictions, providing travelers with unparalleled flexibility. Whether you're carrying a small backpack or a bulky suitcase, rest assured that you can leave whatever you need behind and explore the city unencumbered.`
          )
        },
        {
          image: {
            src: boxFlexible,
            alt: 'Flexible Storage Solutions',
            wrClassName: 'w-[165px] h-[155px] pt-4'
            // ...imageClass
          },
          heading: parsedContent('Flexible Storage Solutions', 'text-blue-river max-w-[175px]'),
          subheading: parsedContent(
            `Whether you're on a brief layover or embarking on an extended adventure, <strong>${appName}</strong> offers flexible storage options tailored to your requirements. Our network of local partners ensures that you can store your belongings for as long as you need.`
          )
        },
        {
          image: {
            src: boxLocalInsights,
            alt: 'localInsights',
            wrClassName: 'w-[194px] h-[155px] pt-4'
            // ...imageClass
          },
          heading: parsedContent('Local Insights and Recommendations', 'text-blue-river'),
          subheading: parsedContent(
            `<strong>${appName}'s</strong> local partners offer you more than just secure storage. They provide you with insider knowledge about the area, including hidden gems, authentic dining recommendations, and ways to immerse yourself in the local culture. With us, you can store your belongings and enhance your travel experience at the same time.`
          )
        }
      ]
    }
  },
  golfClub: {
    // sectionClassName: 'skip-bottom--spacing',
    header: {
      title: parsedContent(`Golf Club Storage in New York with <strong>${appName}</strong>`),
      subtitle: parsedContent(
        `
          <p>One thing that can put a damper on your travel experience is lugging around heavy suitcases. Thankfully, <strong>${appName}</strong> is here to save the day with unparalleled <strong>Golf club storage options in NYC</strong>.</p>
          <p class="text-secondary font-semibold pt-3 md-mn:text-2xl capitalize">Seamless And Affordable Golf Club storage in New York</p>
        `,
        'max-w-[1050px]'
      )
    },
    content: {
      descriptionWrClass: 'md-mn:grid-cols-2 lg-mn:grid-cols-3 gap-7',
      data: [
        {
          image: {
            src: golfConvenience,
            alt: 'convenience',
            ...imageClass
          },
          heading: parsedContent('Convenience at Your Fingertips', 'text-blue-river'),
          subheading: parsedContent(
            `<strong>${appName}</strong> offers a user-friendly app and website, allowing travelers to easily locate and reserve secure storage facilities worldwide. Whether you're in New York City or exploring another destination, our platform ensures hassle-free Golf club storage arrangements.`
          )
        },
        {
          image: {
            src: golfSecureStorage,
            alt: 'Secure Storage Solutions',
            ...imageClass
          },
          heading: parsedContent('Secure Storage Solutions', 'text-blue-river max-w-[150px]'),
          subheading: parsedContent(
            `Our partners guarantee the safety of your belongings while you explore worry-free. With <strong>${appName}</strong>, you can trust that your possessions are in trusted hands, giving you peace of mind throughout your travels.`
          )
        },
        {
          image: {
            src: golfCostEffective,
            alt: 'costEffective',
            ...imageClass
          },
          heading: parsedContent('Cost-Effective Daily Rates', 'text-blue-river max-w-[150px]'),
          subheading: parsedContent(
            `Benefit from budget-friendly daily rates starting at just $10 per day/item. Our transparent pricing ensures affordability without compromising on quality, allowing you to enjoy your day to the fullest without breaking the bank.`
          )
        },
        {
          image: {
            src: golfNoRestrictions,
            alt: 'noRestrictions',
            ...imageClass
          },
          heading: parsedContent('No Size or Weight Restrictions', 'text-blue-river max-w-[175px]'),
          subheading: parsedContent(
            `Unlike traditional storage options, <strong>${appName}</strong> imposes no size or weight restrictions, providing travelers with unparalleled flexibility. Whether you're carrying a small backpack or a bulky suitcase, rest assured that you can leave whatever you need behind and explore the city.`
          )
        },
        {
          image: {
            src: golfFlexible,
            alt: 'Flexible Storage Solutions',
            ...imageClass
          },
          heading: parsedContent('Flexible Storage Solutions', 'text-blue-river max-w-[175px]'),
          subheading: parsedContent(
            `Whether you're on a brief layover or embarking on an extended adventure, <strong>${appName}</strong> offers flexible storage options tailored to your requirements. Our network of local partners ensures that you can store your belongings for as long as you need.`
          )
        },
        {
          image: {
            src: golfLocalInsights,
            alt: 'localInsights',
            ...imageClass
          },
          heading: parsedContent('Local Insights and Recommendations', 'text-blue-river'),
          subheading: parsedContent(
            `Beyond secure storage, our local partners serve as your gateway to discovering hidden gems, savoring authentic dining recommendations, and immersing yourself in the local culture. With <strong>${appName}'s</strong>, you not only store your Golf club but also gain invaluable insights to enhance your travel experience.`
          )
        }
      ]
    }
  },
  skiStorage: {
    // sectionClassName: 'skip-bottom--spacing',
    header: {
      title: parsedContent(`Ski Storage in New York with <strong>${appName}</strong>`),
      subtitle: parsedContent(
        `
          <p>Travel experiences can be spoiled by lugging around heavy ski equipment. Thankfully, <strong>${appName}</strong> is here to save the day with unparalleled <strong>ski storage solutions in NYC</strong>.</p>
          <p class="text-secondary font-semibold pt-3 md-mn:text-2xl capitalize">Seamless And Affordable Ski Storage In New York</p>
        `,
        'max-w-[1050px]'
      )
    },
    content: {
      descriptionWrClass: 'md-mn:grid-cols-2 lg-mn:grid-cols-3 gap-7',
      data: [
        {
          image: {
            src: skiConvenience,
            alt: 'convenience',
            ...imageClass
          },
          heading: parsedContent('Convenience at Your Fingertips', 'text-blue-river max-w-full'),
          subheading: parsedContent(
            `<strong>${appName}</strong> offers a user-friendly website, allowing travelers to easily locate and reserve secure storage facilities worldwide. Whether you're in New York City or exploring another destination, our platform ensures hassle-free Ski storage arrangements.`
          )
        },
        {
          image: {
            src: skiSecureStorage,
            alt: 'Secure Storage Solutions',
            ...imageClass
          },
          heading: parsedContent('Secure Storage Solutions', 'text-blue-river max-w-full'),
          subheading: parsedContent(
            `Our partners guarantee the safety of your belongings while you explore worry-free. With <strong>${appName}</strong>, you can trust that your possessions are in trusted hands, giving you peace of mind throughout your travels.`
          )
        },
        {
          image: {
            src: skiCostEffective,
            alt: 'costEffective',
            ...imageClass
          },
          heading: parsedContent('Cost-Effective Daily Rates', 'text-blue-river max-w-full'),
          subheading: parsedContent(
            `Benefit from budget-friendly daily rates starting at just $10 per day/item. Our transparent pricing ensures affordability without compromising on quality, allowing you to enjoy your day to the fullest without breaking the bank.`
          )
        },
        {
          image: {
            src: skiNoRestrictions,
            alt: 'noRestrictions',
            ...imageClass
          },
          heading: parsedContent('No Size or Weight Restrictions', 'text-blue-river max-w-full'),
          subheading: parsedContent(
            `Unlike traditional storage options, <strong>${appName}</strong> imposes no size or weight restrictions, providing travelers with unparalleled flexibility. Whether you're carrying a small a bulky ski, be sure that you can leave whatever you need behind and explore the city.`
          )
        },
        {
          image: {
            src: skiFlexible,
            alt: 'Flexible Storage Solutions',
            ...imageClass
          },
          heading: parsedContent('Flexible Storage Solutions', 'text-blue-river max-w-full'),
          subheading: parsedContent(
            `Whether you're on a brief layover or embarking on an extended adventure, <strong>${appName}</strong> offers flexible storage options tailored to your requirements. Whether you are looking for solutions like ski boot storage, ski gear storage, snow ski storage or any other ski equipment storage, <strong>${appName}</strong> has got you covered.`
          )
        },
        {
          image: {
            src: skiAdditional,
            alt: 'additional',
            ...imageClass
          },
          heading: parsedContent('Additional Services', 'text-blue-river max-w-full'),
          subheading: parsedContent(
            `<strong>${appName}</strong> offers more than just storage. Need to ship your skis to your next destination? Our reliable shipping ensures your gear arrives safely and on time. We also provide ski equipment rentals With <strong>${appName}</strong>, all your ski storage and travel needs are covered in one convenient place, making your trips smoother and more enjoyable.`
          )
        }
      ]
    }
  },
  snowboardStorage: {
    // sectionClassName: 'skip-bottom--spacing',
    header: {
      title: parsedContent(`Snowboard Storage in New York with <strong>${appName}</strong>`),
      subtitle: parsedContent(
        `
          <p>One thing that can hamper your travel experience is lugging around heavy suitcases. Thankfully, <strong>${appName}</strong> is here to save the day with unparalleled ski and snowboard storage options in NYC.</p>
          <p class="text-secondary font-semibold pt-3 md-mn:text-2xl capitalize">Seamless And Affordable Snowboard Storage In New York</p>
        `,
        'max-w-[1050px]'
      )
    },
    content: {
      descriptionWrClass: 'md-mn:grid-cols-2 lg-mn:grid-cols-3 gap-7',
      data: [
        {
          image: {
            src: snowConvenience,
            alt: 'convenience',
            ...imageClass
          },
          heading: parsedContent('Convenience at Your Fingertips', 'text-blue-river max-w-full'),
          subheading: parsedContent(
            `<strong>${appName}</strong> offers a user-friendly website, allowing travelers to easily locate and reserve secure storage facilities worldwide. Whether you're in New York City or exploring another destination, our platform ensures hassle-free Snowboard storage arrangements.`
          )
        },
        {
          image: {
            src: snowSecureStorage,
            alt: 'Secure Storage Solutions',
            ...imageClass
          },
          heading: parsedContent('Secure Storage Solutions', 'text-blue-river max-w-full'),
          subheading: parsedContent(
            `Our partners guarantee the safety of your belongings while you explore worry-free. With <strong>${appName}</strong>, you can trust that your possessions are in trusted hands, giving you peace of mind throughout your travels.`
          )
        },
        {
          image: {
            src: snowCostEffective,
            alt: 'costEffective',
            ...imageClass
          },
          heading: parsedContent('Cost-Effective Daily Rates', 'text-blue-river max-w-full'),
          subheading: parsedContent(
            `Benefit from budget-friendly daily rates starting at just $10 per day/item. Our transparent pricing ensures affordability without compromising on quality, allowing you to enjoy your day to the fullest without breaking the bank.`
          )
        },
        {
          image: {
            src: snowNoRestrictions,
            alt: 'noRestrictions',
            ...imageClass
          },
          heading: parsedContent('No Size or Weight Restrictions', 'text-blue-river max-w-full'),
          subheading: parsedContent(
            `Unlike traditional storage options, <strong>${appName}</strong> imposes no size or weight restrictions, providing travelers with unparalleled flexibility. Whether you're carrying a small backpack or a bulky suitcase, rest assured that you can leave whatever you need behind and explore the city.`
          )
        },
        {
          image: {
            src: snowFlexible,
            alt: 'Flexible Storage Solutions',
            ...imageClass
          },
          heading: parsedContent('Flexible Storage Solutions', 'text-blue-river max-w-full'),
          subheading: parsedContent(
            `Whether you're on a brief layover or embarking on an extended adventure, <strong>${appName}</strong> offers flexible storage options. Our network of local partners ensures that you can store your belongings for as long as you need, allowing you to make the most of your time in any destination.`
          )
        },
        {
          image: {
            src: snowLocal,
            alt: 'local',
            ...imageClass
          },
          heading: parsedContent('Local Insights and Recommendations', 'text-blue-river max-w-full'),
          subheading: parsedContent(
            `<strong>${appName}</strong> is more than just a place to store your snowboard safely. Our local partners can help you discover new and exciting places. With ShipAndStorage, you'll not only have a secure place for your snowboard. Also, you'll get valuable travel tips to enhance your experience.`
          )
        }
      ]
    }
  }
})
